import { injectable } from "inversify";

const ACCESS_TOKEN = "ACCESS_TOKEN";
const USERNAME = "USER_NAME";
const PASSWORD = "PASSWORD";

@injectable()
export default class TokenRepo {
  getToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN);
  }

  getUsername(): string | null {
    return localStorage.getItem(USERNAME);
  }

  getPassword(): string | null {
    return localStorage.getItem(PASSWORD);
  }

  deleteToken(): void {
    return localStorage.removeItem(ACCESS_TOKEN);
  }

  deleteUsername(): void {
    return localStorage.removeItem(USERNAME);
  }

  deletePassword(): void {
    return localStorage.removeItem(PASSWORD);
  }

  setToken(token: string, userName: string, password?: string) {
    localStorage.setItem(ACCESS_TOKEN, token);
    localStorage.setItem(USERNAME, userName);
    if (password) {
      localStorage.setItem(PASSWORD, password);
    }
  }
}